import { render, staticRenderFns } from "./SignInViaEmailForm.vue?vue&type=template&id=1faf3267&scoped=true"
import script from "./SignInViaEmailForm.vue?vue&type=script&lang=js"
export * from "./SignInViaEmailForm.vue?vue&type=script&lang=js"
import style0 from "./SignInViaEmailForm.vue?vue&type=style&index=0&id=1faf3267&prod&lang=scss&scoped=true"
import style1 from "./SignInViaEmailForm.vue?vue&type=style&index=1&id=1faf3267&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faf3267",
  null
  
)

export default component.exports